<template>
    <div style="display: flex; flex-direction: column; padding: 25px; gap: 25px">
        <span class="scl-ad_title">{{ $t('trainingMaterial') }}</span>
        <div style="padding: 10px" v-if="materials.length">
            <v-pagination v-model="currentPage"  :length="totalPages" :total-visible="10"></v-pagination>
            <v-simple-table style="margin: 12px auto; width: max-content; min-width: 70%">
                <template v-slot:default>
                    <thead>
                    <tr>
                        <th style="font-size: 16px; font-weight: bold">{{ $t('class') }}</th>
                        <th style="font-size: 16px; font-weight: bold">{{ $t('course') }}</th>
                        <th style="font-size: 16px; font-weight: bold">Описание</th>
                        <th style="font-size: 16px; font-weight: bold">Автор</th>
                        <th style="font-size: 16px; font-weight: bold"></th>
                        <th style="font-size: 16px; font-weight: bold"></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="material in materials" :key="material.id">
                        <td>{{material.classLevel}}</td>
                        <td>{{material.courseTitle}}</td>
                        <td style="max-width: 500px;">{{material.description}}</td>
                        <td style="max-width: 500px;">{{material.author}}</td>
                        <td style="max-width: 500px;" ><a :href="material.url">Ссылка на книгу</a></td>
                        <td style="max-width: 500px;">
                            <v-btn :disabled="!material.attachmentUrl" variant="outlined" size="large" icon color="green" @click="downloadFile(material.attachmentUrl)">
                                <v-icon>mdi mdi-download</v-icon>
                            </v-btn></td>
                    </tr>
                    </tbody>
                </template>
            </v-simple-table>
        </div>
    </div>
</template>

<script>
import StudyMaterialService from '@/_services/study-material.service'
import { CourseService } from '@/_services/course.service'
const courseService = new CourseService()

export default {
  name: 'StudyMaterial',
  data () {
    return {
      materials: [],
      currentPage: 1,
      totalPages: 0
    }
  },
  computed: {
    userProfile () {
      return this.$store.state.account.profile
    },
    school () {
      return this.userProfile.schools[0]
    }
  },
  created () {
    this.getAllMaterials(0)
    this.getSchoolCourseList()
  },
  watch: {
    async currentPage (val) {
      if (val === 0) this.getAllMaterials(val)
      else this.getAllMaterials(val - 1)
    }
  },
  methods: {
    getAllMaterials (page) {
      StudyMaterialService.fetchList(this.school.id, page).then((res) => {
        this.materials = res.content
        this.totalPages = res.totalPages
      }).catch((err) => {
        this.$toast.error(err)
      })
    },

    getSchoolCourseList () {
      courseService.listBySchool(this.school.id).then(res => {
        if (res) {
          courseService.listBySchool(this.school.id, '', 0, res.totalElements).then(result => {
            this.courseList = result.content
          })
        }
      })
    }
  }
}
</script>

<style scoped>
th, td{
    vertical-align: middle;
    text-align: center!important;
    border: rgba(198, 203, 212, 0.58) solid 1px;
}
td{
    padding: 10px 16px !important;
}
</style>
